// extracted by mini-css-extract-plugin
export default {"toggleBtn":"ThemeSwitcher_toggleBtn__3L-QS"};